import { faPlayCircle } from "@fortawesome/pro-regular-svg-icons/faPlayCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardMedia, Grid } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { AppImageDimension, AppImages } from "app/appImages";
import { MprcCard, MprcClickable } from "components";
import { CustomVideoSlideRender } from "components/CustomVideoSlideRender";
import { QuestionAttachDto } from "generated/CoreApi_v1";
import HtmlUtils from "lib/HtmlUtils";
import MediaUtils from "lib/MediaUtils";
import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

interface IProps {
    attach: QuestionAttachDto;
    useThumbnail?: boolean;
    altText?: string;
}

export const AssMediaView: React.FC<IProps> = (props) => {
    const { attach, useThumbnail, altText } = props;

    const [dialog, setDialog] = useState<any>();

    const thumbnail = attach.thumbnail;
    let width = thumbnail?.width ?? AppImageDimension.ThumbnailWide.width;
    let height = thumbnail?.height ?? AppImageDimension.ThumbnailWide.height;

    if (attach.imageWide && height > 120) {
        width = width * (height / 120);
        height = 120;
    }

    let thumbnailUrl = thumbnail?.url;
    if ((thumbnailUrl == undefined || thumbnailUrl == null) && attach.mimetype) {
        if (MediaUtils.isVideo(attach.mimetype)) {
            thumbnailUrl = attach.mimetype?.endsWith("mp4") ? AppImages.VideoMp4Thumbnail : AppImages.VideoProcessingThumbnail;
        } else if (MediaUtils.isAudio(attach.mimetype)) {
            thumbnailUrl = AppImages.AudioThumbnail;
        }
    }

    const handleMediaViewer = () => {
        setDialog(<Lightbox
            open
            close={() => setDialog(null)}
            slides={
                MediaUtils.isImage(attach.mimetype!)
                    ?
                    [{
                        type: "image",
                        src: attach.url!,
                        description: attach.fileName,
                        height: attach.height!,
                        width: attach.width!,
                    }]
                    : MediaUtils.isVideoOrAudio(attach.mimetype!)
                        ? [{
                            type: "custom-video-slide",
                            id: attach.fileId,
                            videoId: attach.fileId,
                            url: attach.fileEncodedUrls?.hlsUri ?? attach.url!,
                            height: attach.height!,
                            width: attach.width!,
                            duration: attach.duration ?? 0,
                            mimetype: attach.mimetype,
                            isAudio: attach.mimetype!.indexOf("audio") > -1,
                            isHls: attach.fileEncodedUrls?.hlsUri != null,
                            autoPlay: true,
                            poster: attach.mimetype!.indexOf("audio") > -1
                                ? AppImages.AudioPoster
                                : AppImages.VideoMp4Poster,
                            tracks: attach.mediaTracks ?? []
                        }]
                        :
                        []
            }
            render={
                {
                    slide: ({ slide, offset }) =>
                        "type" in slide && slide.type === "custom-video-slide"
                            ? <CustomVideoSlideRender slide={slide} offset={offset} />
                            : null,
                    buttonPrev: () => null,
                    buttonNext: () => null
                }
            }
            zoom={{
                maxZoomPixelRatio: 1,
                zoomInMultiplier: 2,
                doubleTapDelay: 300,
                doubleClickDelay: 300,
                doubleClickMaxStops: 2,
                keyboardMoveDistance: 50,
                wheelZoomDistanceFactor: 100,
                pinchZoomDistanceFactor: 100,
                scrollToZoom: true
            }}
            plugins={[Captions, Fullscreen, Zoom]}
        />);
    };

    const handleViewAttach = () => {
        if (attach.fileName) MediaUtils.openFileViewerOrDownloadUrl(attach.fileName, attach.url);
        else HtmlUtils.openUrlInNewWindow(attach.url, attach.fileId, { noopener: false, noreferrer: false });
    };

    function getThumbnailFromAttach() {
        if (attach.mimetype && attach.fileName && !MediaUtils.isImage(attach.mimetype) && !MediaUtils.isVideoOrAudio(attach.mimetype)) {
            return <img src={MediaUtils.getFileIcon(attach.fileName)} width={55} />;
        }

        if (thumbnail?.url) {
            return <img src={thumbnail.url} width={55} />;
        }
        return null;
    }

    return (
        <>
            {dialog}

            <MprcCard elevation={0}>
                {
                    attach.imageWide && useThumbnail != true
                        ?
                        <MprcClickable onClick={() => handleMediaViewer()}>
                            <CardMedia
                                component="img"
                                width={width}
                                height={height}
                                image={attach.url}
                                alt={altText}
                            />
                        </MprcClickable>
                        :
                        thumbnailUrl && attach.mimetype && (MediaUtils.isImage(attach.mimetype) || MediaUtils.isVideoOrAudio(attach.mimetype))
                            ?
                            <div style={{ position: "relative" }}>
                                <MprcClickable onClick={() => handleMediaViewer()}>
                                    <CardMedia
                                        component="img"
                                        width={thumbnail?.width ?? AppImageDimension.ThumbnailWide.width}
                                        height={thumbnail?.height ?? AppImageDimension.ThumbnailWide.height}
                                        image={thumbnailUrl}
                                        alt={altText}
                                    />
                                    {
                                        MediaUtils.isVideoOrAudio(attach.mimetype) &&
                                        <div className={AppGlobalClassKeys.centerChild}>
                                            <FontAwesomeIcon icon={faPlayCircle} size="3x" color="white" />
                                        </div>
                                    }
                                </MprcClickable>
                            </div>
                            :
                            <Grid container justifyContent="center" alignItems="flex-start" spacing={2}>
                                <Grid alignSelf="center">
                                    <MprcClickable onClick={() => handleViewAttach()}>
                                        {getThumbnailFromAttach()}
                                    </MprcClickable>
                                </Grid>
                            </Grid>
                }
            </MprcCard>
        </>
    );
};
